import React, { useState, useEffect, useRef } from 'react';
import { useNavigate } from 'react-router-dom';
import { useReactToPrint } from 'react-to-print';
import moment from 'moment';
import { Button } from 'reactstrap';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faAngleLeft, faFilePdf } from '@fortawesome/free-solid-svg-icons';

// componentes
import MainCard from '../../../components/MainCard';
import Stepper from '../../../components/Stepper';

// componentes
import TiposdeRequerimentos from './Components/tiposdeRequerimentos';
import DadosRequerente from './Components/DadosRequerente';
import LocalSupressao from './Components/LocalSupressao';
import Documentos from './Components/Documentos';
import Ficha from '../../Shared/FichaRequerimento';
import FichaDocumento from './Components/FichaDocumento';

//Context
import { useAuth } from '../../../context/auth';

// Helpers
import { objCampo, validarCampos } from '../../../helpers/ValidadorDeCampos';
import { showMessage } from '../../../helpers/message';
import uuid from '../../../helpers/guid';

// API
import requerimento_api from '../../../api/requerimento';
import requerente_api from '../../../api/requerente_api';




function initialStateRequerimento(protocolo) {
    return {
        tipoRequerimento_Id: null,
        dataRequerimento: moment().format(),
        protocolo: protocolo,
        cep: '',
        uf: '',
        cidade: '',
        logradouro: '',
        numero: '',
        complemento: '',
        bairro: '',
        quantidadeItens: '',
        situacao: 'Em Andamento',
        latitude: '',
        longitude: '',
        tipoRequerimentoEtapa_Id: '',
        motivoSolicitacao: '',
        processoConstrutivoImovel: '',
        etapaDeCadastro: 'Documentos',
        requerimentoDocumentos_Ids: []
    }
}

function initialStateRequerente() {
    return {
        telefone: "",
        cep: "",
        logradouro: "",
        numero: "",
        complemento: "",
        bairro: "",
        cidade: "",
        uf: "",
    }
}

export default function Requerimento() {
    const { setLoading, setShowNavigation } = useAuth();



    //Estado de controle do passo ativo
    const [activeStep, setActiveStep] = useState(1);

    // state para criacao do requerimento
    const [requerimento, setRequerimento] = useState(initialStateRequerimento(uuid()));

    //State de controle dos dados do requerente
    const [requerente, setRequerente] = useState(initialStateRequerente());

    //Estado de controle dos erros nos campos
    const [errors, setErrors] = useState({});

    //Estado de controle do conteudo do documento
    const [documento, setDocumento] = useState(null);

    const navigate = useNavigate();

    //referencia da div do documento
    const ref = useRef(null);
    //Estilo da pagina de impressão
    const pageStyle = `
    @page { 
        size: auto;  margin: 0mm ;
    } 
    @media print { 
        body { -webkit-print-color-adjust: exact; } 
    }
    @media print {
        @page{
        size:A4;
        margin:0;
        }


    }
  `;

    const handlePrint = useReactToPrint({
        content: () => ref.current,
        copyStyles: true,
        documentTitle: documento ? documento.identificacao : "",
        pageStyle: pageStyle
    });

    //Campos obrigatorios Dados Requerente 
    const camposDadosRequerente = [
        objCampo({ name: "telefone", required: true }),
        objCampo({ name: "cep", required: true }),
        objCampo({ name: "uf", required: true }),
        objCampo({ name: "cidade", required: true }),
        objCampo({ name: "bairro", required: true }),
        objCampo({ name: "logradouro", required: true }),
        objCampo({ name: "numero", required: true })
    ];

    //Campos obrigatorios Dados Requerente 
    const camposLocalSupressao = [
        objCampo({ name: "cep", required: true }),
        objCampo({ name: "uf", required: true }),
        objCampo({ name: "cidade", required: true }),
        objCampo({ name: "bairro", required: true }),
        objCampo({ name: "logradouro", required: true }),
        objCampo({ name: "numero", required: true }),
        objCampo({ name: "motivoSolicitacao", required: true }),
        objCampo({ name: "quantidadeItens", required: true }),
    ]

    const validateTipoDeRequerimento = () => {
        if (requerimento.tipoRequerimento_Id == null) {
            showMessage("Aviso", "Escolha um tipo de requerimento para continuar!", "info", null);
            return true;
        }
        if (requerimento.tipoRequerimentoEtapa_Id === null || requerimento.tipoRequerimentoEtapa_Id === '') {
            showMessage("Aviso", "O tipo de requerimento selecionado não possui uma etapa inicial configurada. Entre em contato com o administrador.", "info", null);
            return true;
        }
        return false;

    }
    //Função de validação do step de Dados Requerente 
    const validateDadosRequerente = () => {
        const _errors = validarCampos(requerente, camposDadosRequerente);
        setErrors(_errors[0]);
        if (_errors[1].length > 0)
            return true;

        setLoading(true);

        requerente_api.updateDadosRequerente(requerente).then(response => {

        }).catch(ex => {
            showMessage("Erro", ex.message, "error", null)
        })
            .finally(f => setLoading(false));

        return false;
    }
    const validateLocalDeSupressao = (etapa = "Documentos") => {
        const _requerimento = { ...requerimento }
        _requerimento.etapaDeCadastro = etapa;

        const _errors = validarCampos(_requerimento, camposLocalSupressao);
        setErrors(_errors[0]);

        if (_errors[1].length > 0)
            return true;
        if (_requerimento.latitude == "" && _requerimento.longitude == "") {
            showMessage("Aviso", "Informe uma localização para continuar com o cadastro do requerimento!", "info", null);
            return true;
        }
        delete _requerimento.requerimentoDocumentos_Ids;
        if (requerimento.id) {
            setLoading(true);
            requerimento_api.put(_requerimento).then(response => {
                if (etapa == "Finalizado") {
                    showMessage("Sucesso", `Requerimento finalizado com sucesso! Você pode acompanhar o andamento na tela MEU CADASTRO`, "success", () => {
                        setActiveStep(1);
                        setRequerimento(initialStateRequerimento(uuid()));
                    });
                }
                loadRequerimento();
            }).catch(ex => showMessage("Erro", ex.message, "error", null))
                .finally(f => setLoading(false));
        } else {
            setLoading(true);
            requerimento_api.post(_requerimento).then(response => {
                setRequerimento(response.data);
                loadRequerimento();
            }).catch(ex => showMessage("Erro", ex.message, "error", null))
                .finally(f => setLoading(false));
        }

        return false;
    }

    //Passos do cadastro de formulario
    const steps = [
        { text: "Tipo de requerimento", validateStep: validateTipoDeRequerimento },
        { text: "Dados do requerente", validateStep: validateDadosRequerente },
        { text: "Local de supressão", validateStep: validateLocalDeSupressao },
        {
            text: "Documentos", validateStep: () => {
                if (errors.length > 0) {
                    showMessage("Aviso", "Anexe todos os documentos que possuem * para continuar!", "info", null);
                    return true;
                }
                setErrors({});
                return validateLocalDeSupressao("Ficha");
            }
        },
        {
            text: "Ficha", validateStep: () => {
                return validateLocalDeSupressao("Finalizado");
            }
        },
    ];

    //Função que retorna o valor do passo ativo
    const getContent = () => {
        switch (activeStep) {
            case 1:
                return <TiposdeRequerimentos requerimento={requerimento} setRequerimento={setRequerimento} />
            case 2:
                return <DadosRequerente requerente={requerente} setRequerente={setRequerente} errors={errors} />
            case 3:
                return <LocalSupressao requerimento={requerimento} setRequerimento={setRequerimento} errors={errors} />
            case 4:
                return <Documentos requerimento={requerimento} setRequerimento={setRequerimento} setDocumento={setDocumento} loadRequerimento={loadRequerimento} setErrors={setErrors} errors={errors} />
            case 5:
                return <Ficha requerimentoId={requerimento.id} btnVoltar={null} />
        }
    }

    const onSubmit = () => {
        loadRequerimento();
    }

    const loadRequerimento = () => {
        setLoading(true);
        requerimento_api.getRequerimentoCadastro().then(response => {
            if (!!response.data) {
                steps.map((value, index) => {
                    if (value.text == response.data.etapaDeCadastro)
                        setActiveStep(index + 1);
                });
                response.data.quantidadeItens = response.data.quantidadeItens.toString();
                setRequerimento(response.data);
            } else {
                setRequerimento(initialStateRequerimento(uuid()));
            }
        }).catch(ex => showMessage("Erro", ex.message, "error", null))
            .finally(f => setLoading(false));
    }
    useEffect(() => {
        loadRequerimento();
    }, []);

    if (documento)
        return <>
            <div className='mt-4 d-flex align-items-center justify-content-between'>
                <Button onClick={() => {
                    setShowNavigation(true);
                    setDocumento(null)
                }}><FontAwesomeIcon icon={faAngleLeft} /> Voltar</Button>
                <Button onClick={handlePrint} color='danger'><FontAwesomeIcon icon={faFilePdf} /> Gerar PDF</Button>
            </div>
            <MainCard>
                <div ref={ref}>
                    <FichaDocumento documento={documento} />
                </div>
            </MainCard>
        </>
    return (
        <>
            <MainCard>
                <Stepper steps={steps} activeStep={activeStep} setActiveStep={setActiveStep} onSubmit={onSubmit}>
                    {getContent()}
                </Stepper>
            </MainCard>
        </>
    )
}